// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".highlight-text-paragraph--C-dixVWIcSP1NKESrFf0I{margin:0px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", "",{"version":3,"sources":["webpack://src/components/common/HighlightText/highlightText.module.scss"],"names":[],"mappings":"AAAA,iDACC,UAAA,CACA,kBAAA,CACA,eAAA,CACA,sBAAA","sourcesContent":[".paragraph {\r\n\tmargin: 0px;\r\n\twhite-space: nowrap;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paragraph": "highlight-text-paragraph--C-dixVWIcSP1NKESrFf0I"
};
export default ___CSS_LOADER_EXPORT___;
